import React from 'react';

import {Trans} from '../../libs/shared/core/src/helpers/internationalization/react';
import {TeamModel} from '../../libs/shared/core/src/models/api/teamModel';
import {ApiTokenScopesEnum} from '../models/api/apiTokenModel';

/*
 * Interface.
 */

export interface ApiTokenScopeModel {
  type: ApiTokenScopesEnum;
  value: string;
  searchValue: string;
  display: React.ReactNode;
}

/*
 * Constants.
 */

export const defaultApiTokenScopes: ReadonlyArray<ApiTokenScopeModel> = [
  {
    type: ApiTokenScopesEnum.AUTO_PROVISIONING,
    value: ApiTokenScopesEnum.AUTO_PROVISIONING,
    searchValue: 'auto provisioning',
    display: <Trans id="api-scope-auto-provisioning">Auto Provisioning</Trans>,
  },
  {
    type: ApiTokenScopesEnum.PROVISIONING,
    value: ApiTokenScopesEnum.PROVISIONING,
    searchValue: 'provisioning',
    display: <Trans id="api-scope-provisioning">Provisioning</Trans>,
  },
  {
    type: ApiTokenScopesEnum.PRIVATE,
    value: ApiTokenScopesEnum.PRIVATE,
    searchValue: 'private resources',
    display: <Trans id="api-scope-private">Private Resources</Trans>,
  },
  {
    type: ApiTokenScopesEnum.SHARED,
    value: ApiTokenScopesEnum.SHARED,
    searchValue: 'shared resources',
    display: <Trans id="api-scope-shared">Shared Resources</Trans>,
  },
  {
    type: ApiTokenScopesEnum.KNOWLEDGE_BASE,
    value: ApiTokenScopesEnum.KNOWLEDGE_BASE,
    searchValue: 'knowledge base',
    display: <Trans id="api-scope-kb">Knowledge Base</Trans>,
  },
];

/*
 * Helpers.
 */

export function buildApiTokenScopeFromTeam(team: TeamModel): ApiTokenScopeModel {
  return {
    type: ApiTokenScopesEnum.TEAM,
    value: team.namespace,
    searchValue: team.name.toLowerCase(),
    display: <Trans id="api-scope-team">Workspace: {team.name} Resources</Trans>,
  };
}
